module.exports = __webpack_public_path__ + "school/img/microCourseDetailBg.b4503c85.jpg";